module.exports = __webpack_public_path__ + "img/webSelect_2_2.1c04dea8.png";